import { useAppStoreBase } from './app.store';
import type { AppState, AppStore } from './app.types';

// ========  Store Selectors (Non Reactive) - To be used with functions outside react (NON-REACTIVE) =======
// #region Non Reactive Selectors
const appStoreStateSelector = (): AppState => useAppStoreBase.getState().state;

const heartbeatTSSelector = (): number => appStoreStateSelector().heartbeatTS;

const publicHeartbeatTSSelector = (): number => appStoreStateSelector().publicHeartbeatTS;

// #endregion Non Reactive Selectors

// ========  Reactive Selectors - To be used with React Components (REACTIVE) ========
// Ex: const heartbeatTS = useAppStoreBase(selectAppStoreHeartbeatTS)
// #region Reactive Selectors
const selectAppStoreHeartbeatTS = (store: AppStore) => store.state.heartbeatTS;
const selectAppStorePublicHeartbeatTS = (store: AppStore) =>
  store.state.publicHeartbeatTS;

// #endregion Reactive Selectors

export {
  // #region Non Reactive Selectors
  heartbeatTSSelector,
  publicHeartbeatTSSelector,
  // #endregion

  // #region Reactive Selectors (use with useAppStoreBase)
  selectAppStoreHeartbeatTS,
  selectAppStorePublicHeartbeatTS,
  // #endregion
};
